'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ToolbarButton = require('./ToolbarButton');

var _ToolbarButton2 = _interopRequireDefault(_ToolbarButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasInline = function hasInline(value, inline) {
  return value.inlines.some(function (node) {
    return node.type === inline;
  });
};

var inlineStrategy = function inlineStrategy(value, inline) {
  var change = value.change();

  if (value.isExpanded) {
    if (hasInline(value, inline)) {
      return change.unwrapInline(inline);
    }
    return change.unwrapInline(inline).wrapInline(inline);
  }
  return change;
};

var InlineButton = function InlineButton(_ref) {
  var inline = _ref.inline,
      title = _ref.title,
      icon = _ref.icon,
      value = _ref.value,
      onChange = _ref.onChange;
  return _react2.default.createElement(_ToolbarButton2.default, {
    title: title,
    icon: icon,
    active: hasInline(value, inline),
    onMouseDown: function onMouseDown(e) {
      return onChange(inlineStrategy(value, inline));
    }
  });
};

InlineButton.propTypes = {
  inline: _propTypes2.default.string.isRequired,
  title: _propTypes2.default.string.isRequired,
  icon: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.object.isRequired,
  onChange: _propTypes2.default.func.isRequired
};

exports.default = InlineButton;